import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { WidgetsModule } from '../../widgets/widgets.module';
import { SettingsComponent } from './settings.component';
import { DataImportComponent } from './data-import.component';
import { FlatFileModule } from '../../components/flat-file/flat-file.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmailDigestModule } from '../email-digest/email-digest.module';
import { ManageScreensModule } from '../../components/manage-screens/manage-screens.module';
import { AdvancedSettingComponent } from './advanced-setting.component';
import { ManageRelationshipDialogComponent } from './manage-relationship-dialog/manage-relationship-dialog.component';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { SettingsRoutingModule } from './settings-routing.module';
import { AdminPageLayoutModule } from '../../components/admin-pages/admin-page.module';

@NgModule({
    imports: [
        SettingsRoutingModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DropDownsModule,
        WidgetsModule,
        EmailDigestModule,
        FlatFileModule,
        ManageScreensModule,
        InputsModule,
        AdminPageLayoutModule
    ],
    declarations: [
        SettingsComponent,
        DataImportComponent,
        AdvancedSettingComponent,
        ManageRelationshipDialogComponent
    ],
    providers: [
    ],
    exports: [
        SettingsComponent,
        ManageRelationshipDialogComponent,
    ],
})
export class SettingsModule { }
